import './switch.less';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import cn from 'classname';
import axios from 'axios';

const propTypes = {
	intl: PropTypes.func,
	filterContextForSwitchControl: PropTypes.string
};

const IS_EVERAD  = process.env.CPA_ENV === 'everad';

class Switch extends React.Component {
	constructor(props) {
		super(props);
		this.state = { spam_by_count: null };
	}
	componentDidMount() {
		axios.get(`v2/analytics/last-unaccepted-count?type=9`)
			.then(data => this.setState(state => ({ ...state, spam_by_count: data.data })));
		axios.get(`v2/analytics/last-unaccepted-count?type=10`)
			.then(data => this.setState(state => ({ ...state, invalid_params_count: data.data })));
	}

	render() {
		const { intl, filterContextForSwitchControl, can } = this.props;

		return (
			<div className="statistics__switch-control">
				<Link
					to={`statistics/general?${makeQuery(filterContextForSwitchControl)}`}
					className={cn({
						'general': true,
						'active': isActiveByPathname('statistics/general')
					})}>
					<span className="icon" />
					<span>{intl('General statistics')}</span>
				</Link>
				<Link
					to={`statistics/conversions?${makeQuery(filterContextForSwitchControl)}`}
					className={cn({
						'conversions': true,
						'active': isActiveByPathname('statistics/conversions')
					})}>
					<span className="icon" />
					<span>{intl('Conversions')}</span>
				</Link>
				{
					can('autotrash_view') &&
					<Link
						to={`statistics/unacceptable-conversions`}
						className={cn({
							'unacceptable-conversions': true,
							'active': isActiveByPathname('statistics/unacceptable-conversions')
						})}>
						<span className="icon" />
						<span>
							{intl('Banned')}
							<span className="small_navigation_link">
								(Invalid: {this.state.invalid_params_count })
							</span>
						</span>
						{
							this.state.spam_by_count &&
							<span className="unacceptable-conversions-count">{this.state.spam_by_count}</span>
						}

					</Link>
				}
				{
					can('autotrash_view') &&
					<Link
						to={`statistics/unacceptable-stat`}
						className={cn({
							'unacceptable-conversions': true,
							'active': isActiveByPathname('statistics/unacceptable-stat')
						})}>
						<span className="icon" />
						<span>
							{intl('Banned stat')}
						</span>
					</Link>
				}
				{
					IS_EVERAD &&
					<Link
						to={`statistics/invalid`}
						className={cn({
							'unacceptable-conversions': true,
							'active': isActiveByPathname('statistics/invalid')
						})}>
						<span className="icon" />
						<span>
							{intl('Rejected & Trash')}
						</span>
					</Link>
				}
			</div>
		);
	}
}

Switch.propTypes = propTypes;

const makeQuery = filterContext => {
	return filterContext && filterContext.length ? filterContext : '';
};

const isActiveByPathname = pathName => window.location.pathname.indexOf(pathName) > -1;

export default Switch;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/components/switch.js